export const persistCollectionKey = 'add-collection';
export const persistCollectionForeignKey = 'add-collection-foreign';
